import { Injectable } from '@angular/core';

import { DataService } from '../data.service';
import { SimpleRepository } from './_simple.repository';
import { IGetallDTO } from 'src/app/model/dto/getall.dto';
import { Currency } from 'src/app/model/orm/currency.model';

@Injectable()
export class CurrenciesRepository extends SimpleRepository<Currency> {
    constructor(protected dataService: DataService) {
        super();
        this.sortBy = "pos";
    }
    
    public load(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (new Date().getTime() - this.loadedAt < this.ttl) {
                resolve();
            } else {
                const dto: IGetallDTO = {sortBy: this.sortBy, sortDir: this.sortDir};
                this.dataService.currenciesAll(dto).subscribe(res => {                                                                                
                    if (res.statusCode === 200) {
                        this.build(res.data);                           
                        this.loadedAt = new Date().getTime();
                        resolve();
                    } else {                        
                        reject(res.statusCode+": "+res.error);
                    }
                }, err => {
                    reject(err.message);
                });
            }            
        });
    }    

    public build(currencies: Array<Currency> = []): void {
        this.xl = currencies.length ? currencies.map(d => new Currency().build(d)) : [];
    }
}
